import { LeftOutlined, RightOutlined } from "@ant-design/icons"
import { Button, Space } from "antd"
import { FC, useMemo } from "react"

export type GNPaginationProps = {
  page: number
  pageSize: number
  total: number
  onChange: (page: number) => void
}

export const GNPagination: FC<GNPaginationProps> = ({ page, pageSize, total, onChange }) => {
  const totalPages = useMemo(() => Math.ceil(total / pageSize), [total, pageSize])

  return (
    <Space>
      <Button
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        icon={<LeftOutlined />}
        size='middle'
      />
      <Button
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        icon={<RightOutlined />}
        size='middle'
      />
    </Space>
  )
}